import script from "./Image-Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Image-Text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__